import { createContext, useState } from "react";

const emptyData: any = {
    pageHeader: {
        title: "Metrix Reader",
        backButton: false,
        previousPage: null,
        actionButton: false,
        nextPage: null,
    },
    hideNavbar: false,
    selectedBluetoothDevice: null,
    responseDevice: null,
};

export const DataContext = createContext(emptyData as any);

export const DataProvider = ({ children }: any) => {
    const [data, setData] = useState(emptyData as any);

    return <DataContext.Provider value={{data, setData}}>{children}</DataContext.Provider>
};